import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import { BsBoxSeam } from "react-icons/bs";

const Inventory = () => {
    return (
        <BaseLayout>
            <div className="flex flex-col items-center justify-center w-full h-full gap-6">
                <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-teal-500/20 to-green-500/20 border br-1">
                    <BsBoxSeam className="text-4xl text-teal-400" />
                </div>
                <div className="text-center">
                    <h1 className="text-3xl font-bold p-text mb-2">Inventory</h1>
                    <p className="text-lg s-text max-w-md">
                        Inventory management and tracking coming soon.
                    </p>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-1 border br-1">
                    <div className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse"></div>
                    <span className="text-sm s-text">Under Development</span>
                </div>
            </div>
        </BaseLayout>
    );
};

export default Inventory;
